const DEFAULT_META_TAGS_SUCCESS = "DEFAULT_META_TAGS_SUCCESS";

export { DEFAULT_META_TAGS_SUCCESS };